import { faClose, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

import "../../styles/dialog.css";


export const HomeActionDialog = ({ visible, toggleClose }) => {
    const navigateTo = useNavigate();
    const actionList = [
        {
            caption: "Build a responsive website for my business/organization",
            url: "/services/web-development?options=true"
        },
        {
            caption: "Build an intelligent mobile application",
            url: "/services/mobile-development?options=true"
        },
        {
            caption: "Create a design for my organization",
            url: "/services/graphics-design?options=true"
        },
        {
            caption: "Secure my website/mobile phone/ organization",
            url: "/services/cyber-security?options=true"
        }
    ];
    return (
        <div className={classNames("st-bl-bg", { "visible": visible })}>
            <div className={classNames("dialog-box", { "zoom": visible })}>
                <div className="dialog-close">
                    <button className="cl-btn" onClick={toggleClose}>
                        <FontAwesomeIcon icon={faClose} />
                    </button>
                </div>
                <div className={classNames("dialog-caption")}>
                    Hello, how can we help?
                </div>
                <div className="action-list">
                    {actionList.map((item) => {
                        return (
                            <button 
                                className="act-list-item"
                                onClick={() => navigateTo(item.url) }
                            >
                                <FontAwesomeIcon icon={faPlusCircle} className="d-ico" />
                                <span className="item-caption">{item.caption}</span>
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}